/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { consola as defaultConsola, createConsola } from "consola";

// https://github.com/unjs/consola?tab=readme-ov-file#await-promptmessage--type-cancel-
const cancelSymbol = Symbol.for("cancel");
export const consola = createConsola({
  async prompt(message, opts) {
    const response = await defaultConsola.prompt(message, {
      ...opts,
      cancel: opts?.cancel ?? "symbol"
    });
    if (response === cancelSymbol) {
      defaultConsola.fail("Operation cancelled");
      process.exit(0);
    }
    return response;
  }
});